import BasePicker from 'components/partials/Fields/DatePicker';
import { Field, useFormikContext } from 'formik';

const DatePicker = ({ formik, type = 'date', placeholder = undefined, onChange, ...props }) => {
    const { setFieldTouched } = useFormikContext();

    if (formik) return (
        <Field name={props.name}>
            {({ field, form }) => {
                return (
                    <BasePicker
                        format={type === 'time' && 'h:mm A'}
                        type={type}
                        error={form?.touched[props.name] && form?.errors[props.name] ? form.errors[props.name] : null}
                        dateFormat={!(type === 'time')}
                        placeholder={placeholder ?? (type === 'time' ? 'HH:MM AM/PM' : 'MM/DD/YYYY')}
                        re_validate={false}
                        timeFormat={type === 'time'}
                        updateMethod={({ value }) => {
                            onChange && onChange({ value, name: props.name });
                            field.onChange({ target: { value, name: props.name } });
                        }}
                        defaultValue={field.value || ''}
                        onBlur={(e) => {
                            setFieldTouched(props.name, true, true);
                        }}
                        {...props}
                    />
                );
            }}
        </Field>
    );

    return <BasePicker {...props} />;
};

export default DatePicker;